<mat-card appearance="outlined" *ngIf="trustList.value.length || companyList.value.length">
  <mat-card-header>
    <mat-card-title>Company / Trust Incomes</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="trustList.value.length">
      <div class="row">
        <!-- Trust -->
        <ng-container *ngFor="let companyIncome of formGroup.get('trustIncomeList').controls; let brwIndex = index;">
          <div class="row col-sm-12" *ngIf="trustList.value[brwIndex]?.trustType !== 'security-trust'">
            <div class="col-sm-12">
              <hr/>
              <h4>{{trustList.value[brwIndex]?.trustName || 'Trust ' + (brwIndex + 1)}} <small
                *ngIf="trustList.value[brwIndex]?.trustType">[{{trustList.value[brwIndex]?.trustType | uppercase }}
                ]</small></h4>
            </div>
            <div class="col-sm-12">
              <mat-card appearance="outlined" class="mb-4" [formGroup]="companyIncome">
                <mat-card-content>
                  <!-- Other Income -->
                  <ng-container *ngIf="trustList.value[brwIndex]?.trustType === 'smsf-trust'">
                    <div class="row">
                      <div class="col-sm-8">
                        <h5>Other Incomes</h5>
                      </div>
                      <div class="col-sm-4 text-end">
                        <button mat-raised-button color="primary" type="button" class="fmc-button-primary"
                                (click)="addIncome(companyIncome.get('otherIncomes'))">Add Income
                        </button>
                      </div>
                    </div>
                    <div class="row"
                         *ngFor="let otherIncome of companyIncome.get('otherIncomes').controls; let otherIncomeIndex = index">
                      <ng-container [formGroup]="otherIncome">
                        <div class="col-sm-4">
                          <mat-form-field appearance="outline">
                            <mat-label>Income type</mat-label>
                            <mat-select placeholder="Income type" formControlName="type">
                              <ng-container
                                *ngIf="trustList.value[brwIndex]?.trustType !== 'smsf-trust' else smsfIncomes">
                                <mat-option *ngFor="let source of otherIncomeSourceTypes"
                                            [value]="source.id">{{source.text}}</mat-option>
                              </ng-container>
                              <ng-template #smsfIncomes>
                                <mat-option *ngFor="let source of smsfIncomeSourceTypes"
                                            [value]="source.id">{{source.text}}</mat-option>
                              </ng-template>
                            </mat-select>
                            <mat-error>
                              <app-validation-partial [formGroup]="otherIncome"
                                                      [fieldName]="'type'"></app-validation-partial>
                            </mat-error>
                          </mat-form-field>
                          <ng-template #smsfIncome>

                          </ng-template>
                        </div>
                        <div class="col-sm-4">
                          <mat-form-field appearance="outline">
                            <mat-label>Select a frequency</mat-label>
                            <mat-select placeholder="Select a frequency" formControlName="frequency">
                              <mat-option *ngFor="let frequency of frequencyTypes"
                                          [value]="frequency.id">{{frequency.text}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                          <mat-form-field appearance="outline">
                            <mat-label>Amount</mat-label>
                            <input matInput placeholder="Amount" matInputCommified formControlName="amount">
                            <span matPrefix>$&nbsp;</span>
                            <mat-error>
                              <app-validation-partial [formGroup]="otherIncome"
                                                      [fieldName]="'amount'"></app-validation-partial>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-1 d-flex align-items-center">
                          <button type="button" mat-icon-button
                                  (click)="removeIncome(companyIncome.get('otherIncomes'), otherIncomeIndex)" color="warn"
                                  *ngIf="!first">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                  <!-- Business Income -->
                  <ng-container *ngIf="trustList.value[brwIndex]?.trustType !== 'smsf-trust'">
                    <app-self-employed-details
                      [personList]="personList"
                      [formGroup]="companyIncome">
                    </app-self-employed-details>
                  </ng-container>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="companyList.value.length">
      <div class="row">
        <!-- Company -->
        <ng-container *ngFor="let companyIncome of formGroup.get('companyIncomeList').controls; let brwIndex = index;">
          <div class="row col-sm-12" *ngIf="companyList?.value[brwIndex]?.trusteeOf === null">
            <div class="col-sm-12">
              <hr/>
              <h4>{{companyList.value[brwIndex]?.companyName || 'Company ' + (brwIndex + 1)}} <small
                *ngIf="companyList?.value[brwIndex]?.trusteeOf >= 0 && trustList?.value[companyList?.value[brwIndex]?.trusteeOf]">[Trustee
                of {{trustList?.value[companyList?.value[brwIndex]?.trusteeOf]?.trustName || trustList?.value[companyList?.value[brwIndex]?.trusteeOf]?.trustType || 'Trust ' + (companyList?.value[brwIndex]?.trusteeOf + 1) | uppercase }}
                ]</small></h4>
            </div>
            <div class="col-sm-12">
              <mat-card appearance="outlined" class="mb-4" [formGroup]="companyIncome">
                <mat-card-content>
                  <!-- Business Income -->
                  <ng-container>
                    <app-self-employed-details
                      [personList]="personList"
                      [formGroup]="companyIncome">
                    </app-self-employed-details>
                  </ng-container>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
